var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chenggong"},[_c('img',{attrs:{"src":require("@/assets/image/success.png"),"alt":"","srcset":""}}),_c('div',{staticClass:"title"},[_vm._v("发起成功")]),_c('div',{staticClass:"desc"},[_vm._v("请查看短信根据提示进行操作")]),_c('el-button',{staticClass:"button",attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }